import React from 'react'

const BenefitsBanner: React.FC = () => {
  return (
    <section className='benefits-banner' style={{ background: '#0a2a3a', padding: '56px 0', margin: '0', width: '100%' }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 24px' }}>
        <h2 style={{ fontWeight: 700, fontSize: '2.2rem', marginBottom: '18px', color: '#fff' }}>Twoje korzyści</h2>
        <p style={{ fontSize: '1.15rem', color: '#e0f7fa', marginBottom: '38px', maxWidth: '700px' }}>
          Kreatlo to coś więcej niż baza produktów – to kompleksowe narzędzie marketingowe stworzone z myślą o producentach, wykonawcach którzy chcą realnie zwiększyć swoją rozpoznawalność w swojej branży.
        </p>
        <div className='benefits-columns' style={{ display: 'flex', gap: '48px', flexWrap: 'wrap', justifyContent: 'center' }}>
          {/* Lewa kolumna */}
          <div style={{ flex: 1, minWidth: '320px', maxWidth: '520px', display: 'flex', flexDirection: 'column', gap: '32px' }}>
            <BenefitItem
              icon='/assets/images/icons/Pozycjonowanie produktów.png'
              title='Pozycjonowanie produktów, usług'
              description='Oferujemy kompleksowy pakiet marketingowy, który pomaga zwiększyć widoczność poprzez promowanie produktów/usług. Pozycjonowanie na listach wyszukiwania zależy od wybranego pakietu, aktywnego promowania, jakości udostępnionych materiałów oraz ich popularności wśród projektantów.'
            />
            <BenefitItem
              icon='/assets/images/icons/Pliki gotowe do użycia.png'
              title='Pliki gotowe do użycia, zawsze aktualne'
              description='Modele Twoich produktów są podstawą decyzji projektowych – ich jakość i aktualność decydują o tym, czy Twoje produkty trafią do projektu, czy zostaną pominięte. Dlatego oferujemy kompleksową usługę weryfikacji i aktualizacji Twojej biblioteki modeli:'
              listItems={[
                '- zawierają precyzyjne i zgodne z rzeczywistością dane techniczne,',
                '- działają bezbłędnie w najnowszych wersjach oprogramowania,',
                '- posiadają kompletne i aktualne metadane,',
                '- mają aktywne, działające linki prowadzące do Twojej strony i katalogów produktowych.'
              ]}
            />
            <BenefitItem
              icon='/assets/images/icons/Obsługa konta.png'
              title='Obsługa konta'
              description='Czas to Twój kapitał – dlatego nasz zespół zajmie się obsługą Twojego profilu. Dodamy produkty, artykuły, zdjęcia, case study marki, zaktualizujemy treści i zadbamy o ich atrakcyjną prezentację.'
              largeIcon
            />
          </div>
          {/* Prawa kolumna */}
          <div style={{ flex: 1, minWidth: '320px', maxWidth: '520px', display: 'flex', flexDirection: 'column', gap: '32px' }}>
            <BenefitItem
              icon='/assets/images/icons/Zapoznaj się ze statystykami.png'
              title='Zapoznaj się ze statystykami Twojej marki'
              description='Nie zgaduj – analizuj. Dzięki wbudowanym narzędziom analitycznym podejmujesz decyzje, które naprawdę mają sens – bo oparte są na liczbach, nie domysłach. Zobacz, co naprawdę działa – i podejmuj lepsze decyzje z pomocą inteligentnych analiz:'
              listItems={[
                '- liczbę wyświetleń profilu,',
                '- liczbę pobrań plików,',
                '- produkty, które zostały wykorzystane do projektów.'
              ]}
            />
            <BenefitItem
              icon='/assets/images/icons/Zobacz, kto naprawdę stoi.png'
              title='Zobacz, kto naprawdę stoi za Twoimi statystykami'
              description='Wyobraź sobie, że wiesz nie tylko ile razy pobrano Twój katalog lub obiekt 3D, ale również kto konkretnie się nim zainteresował się Twoją usługą. Na Kreatlo przekształcamy anonimowe liczby w konkretne osoby, firmy i lokalizacje.'
            />
            <BenefitItem
              icon='/assets/images/icons/Komunikacja z projektantami.png'
              title='Komunikacja z projektantami'
              description='W trakcie pracy nad projektem liczy się szybki dostęp do sprawdzonych informacji. Dlatego umożliwiamy projektantom natychmiastowy kontakt z Twoją marką, wiadomość trafia od razu do właściwej osoby w Twoim zespole – bez zbędnych pośredników, przez przejrzyste i wygodne formularze.'
              largeIcon
            />
          </div>
        </div>
      </div>
      <style>{`
        @media (max-width: 1100px) {
          .benefits-columns { flex-direction: column; gap: 32px; }
          .benefits-banner { padding: 32px 0 !important; }
        }
        @media (max-width: 700px) {
          .benefits-banner { padding: 18px 0 !important; }
          .benefits-columns { gap: 18px !important; }
          .benefits-banner h2 { font-size: 1.2rem !important; }
          .benefits-banner p, .benefits-banner li { font-size: 0.98rem !important; }
        }
      `}
      </style>
    </section>
  )
}

interface BenefitItemProps {
  icon: string
  title: string
  description: string
  listItems?: string[]
  largeIcon?: boolean
}

const BenefitItem: React.FC<BenefitItemProps> = ({ icon, title, description, listItems, largeIcon }) => {
  return (
    <div style={{ display: 'flex', gap: '18px', alignItems: 'flex-start' }}>
      <img src={icon} alt={title} style={{ width: largeIcon ? '80px' : '64px', height: largeIcon ? '80px' : '64px', marginTop: 2 }} />
      <div>
        <h4 style={{ fontWeight: 600, fontSize: '1.15rem', margin: 0, color: '#fff' }}>{title}</h4>
        <p style={{ margin: 0, color: '#e0f7fa' }}>
          {description}
          {(listItems != null) && (
            <ul style={{ margin: '8px 0 0 18px', padding: 0, color: '#e0f7fa', fontSize: '0.98rem' }}>
              {listItems.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          )}
        </p>
      </div>
    </div>
  )
}

export default BenefitsBanner
